import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
	cachedUpdates,
	markInboxRead,
	refreshInbox,
	unwatchSeat,
	watchedSeats,
	type SeatUpdate,
} from "../lib/inbox";
import { useLocalState } from "../state/LocalStateProvider";
export function InboxPage() {
	const { state } = useLocalState();
	const [updates, setUpdates] = useState<SeatUpdate[]>(cachedUpdates),
		[error, setError] = useState(""),
		[retry, setRetry] = useState(0),
		[watch, setWatch] = useState(watchedSeats);
	useEffect(() => {
		let live = true;
		refreshInbox(
			[
				state.viewingPlan.eventTitle,
				...state.upcomingPlans.map((p) => p.eventTitle),
			].filter(Boolean),
		)
			.then((rows) => {
				if (live) {
					setUpdates(rows);
					setError("");
				}
			})
			.catch(() => {
				if (live)
					setError(
						"연결되면 새 소식을 확인해요. 마지막으로 받은 소식은 그대로 있어요.",
					);
			});
		return () => {
			live = false;
		};
	}, [retry, state.viewingPlan.eventTitle, state.upcomingPlans]);
	return (
		<section className="page narrow stack-lg">
			<h1>관심 자리 소식</h1>
			{error ? (
				<p role="alert">
					{error}
					<button className="button" onClick={() => setRetry(retry + 1)}>
						다시 확인하기
					</button>
				</p>
			) : null}
			{!watch.length ? (
				<>
					<p>궁금한 자리에 별을 누르면 여기로 소식이 와요.</p>
					<Link to="/start">관심 자리 고르기</Link>
				</>
			) : updates.length ? (
				<ul>
					{updates.map((u) => (
						<li key={u.id}>
							<Link
								to={u.href}
								onClick={() => {
									markInboxRead();
								}}
							>
								{u.text}
							</Link>
						</li>
					))}
				</ul>
			) : (
				<p>
					아직 새 소식이 없어요. 관심 자리에 기록이 생기면 다음 방문에 보여
					드려요.
				</p>
			)}
			<button
				className="button"
				onClick={() => {
					markInboxRead();
					setUpdates([]);
				}}
			>
				소식 모두 읽음으로 바꾸기
			</button>
			<details>
				<summary>관심 자리 관리하기 · {watch.length}/5</summary>
				{watch.map((key) => (
					<p key={key}>
						<Link to={`/seat/${encodeURIComponent(key)}`}>
							{key.split(":").slice(2).join(" · ")}
						</Link>
						<button
							className="button"
							onClick={() => {
								unwatchSeat(key);
								setWatch(watchedSeats());
							}}
						>
							소식 받기 해제
						</button>
					</p>
				))}
			</details>
		</section>
	);
}
